export default "__VITE_ASSET__48bf0a8d__"